import domain from '@framework/config/domain';
import env from '@framework/env/env';

const config = {
  name: 'CreditFlow',
  code: 'creditflowresearch' as const,
  supportEmail: `support@${ domain.creditflowresearchDomain }`,
  supportPhoneNumber: env('FINSIGHT_WEB___SUPPORT__PHONE'),
  hostname: `${ domain.creditflowresearchDomain }`,
  ga: {
    trackingId: env('GA__TRACKING_ID_CREDITFLOWRESEARCH'),
  },
  gtm: {
    trackingId: env('FRONTEND___GOOGLE_TAG_MANAGER__TENANT_CREDITFLOWRESEARCH__GTM_ID'),
  },
  supportChatId: env('FRONT_APP__CHAT_ID_TENANT_FINSIGHT'),
  newissueEmail: `newissue@${ domain.finsightDomain }`,
  api: {
    external: `${ domain.protocol }//${ domain.finsightDomain }`,
    internal: {
      finsightWeb: env('FINSIGHT_WEB_WS__HOSTNAME_INTERNAL'),
      finsightStrats: env('FINSIGHT_STRATS_WS__HOSTNAME_INTERNAL'),
      cfrApi: env('CFR_API_WS__HOSTNAME_INTERNAL'),
    },
  },
  featureToggle: {
    emmarket: { cookieName: 'emmarket' },
    openmarket: { cookieName: 'openmarket' },
    hideTopCompanies: { cookieName: 'hideTopCompanies' },
    hidePostsFilters: { cookieName: 'hidePostsFilters' },
    corporateActiveCalendar: { cookieName: 'corporateActiveCalendar' },
    bondScreenerCustomViews: { cookieName: 'bondScreenerCustomViews' },
    bondScreenerCustomViewsDescription: { cookieName: 'bondScreenerCustomViewsDescription' },
    bondScreenerCustomViewsSelect: { cookieName: 'bondScreenerCustomViewsSelect' },
    bondScreenerCustomViewsRename: { cookieName: 'bondScreenerCustomViewsRename' },
    bondScreenerCustomViewsPresets: { cookieName: 'bondScreenerCustomViewsPresets' },
    bondScreenerCustomViewsSearch: { cookieName: 'bondScreenerCustomViewsSearch' },
    bondScreenerExportDropdown: { cookieName: 'bondScreenerExportDropdown' },
    bondScreenerSelectView: { cookieName: 'bondScreenerSelectView' },
    darkThemeEnabled: { cookieName: 'darkThemeEnabled' },
    europeanMarketOpenAccess: { cookieName: 'europeanMarketOpenAccess' },
    settingsAndSubscriptions: { cookieName: 'settingsAndSubscriptions' },
    askAi: { cookieName: 'askAi' },
  },
};

export default config;
